import { getAuth } from "firebase/auth";

let auth = null;

const configureFirebaseAuth = () => {
  if (!auth) {
    auth = getAuth();
  }

  return auth;
};

export default configureFirebaseAuth;
